import { useState } from "react";
import "./Header.scss";
import { Link, useParams } from "react-router-dom";
import {
  AuditOutlined,
  CaretDownFilled,
  ContactsOutlined,
  FileDoneOutlined,
  FilePdfOutlined,
  FileProtectOutlined,
  FileSyncOutlined,
  GlobalOutlined,
  HomeOutlined,
  IdcardOutlined,
  LogoutOutlined,
  TeamOutlined,
  UserAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import ApplicationDrawer from "../ApplicationDrawer/ApplicationDrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  getAboutUsIntro,
  getApprisers,
  getApprovedProjectDetails,
  getApprovedProjects,
  getBoardMembers,
  getCompletedProjectDetails,
  getCompletedProjects,
  getConsultants,
  getContacts,
  getCouncilMembers,
  getEventDetails,
  getEventsInAzerbaijan,
  getEventsInKyrgyzstan,
  getInsuranceCompanies,
  getNews,
  getNewsDetails,
  getPartnerBuyers,
  getPartnerSuppliers,
  getReports,
  getTenderDetails,
  getTenders,
  logout,
  setLang,
} from "../../redux/ApplicationSlice";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import SubMenu from "antd/es/menu/SubMenu";
import s from "./Header.scss";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.application.lang);
  const params = useParams();
  const { t } = useTranslation();
  const user = useSelector((state) => state.application.user);

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    dispatch(getAboutUsIntro());
    dispatch(getReports());
    dispatch(getNews());
    dispatch(getTenders());
    dispatch(getBoardMembers());
    dispatch(getCouncilMembers());
    dispatch(getContacts());
    dispatch(getConsultants());
    dispatch(getApprisers());
    dispatch(getInsuranceCompanies());
    dispatch(getApprovedProjects());
    dispatch(getCompletedProjects());
    dispatch(getPartnerBuyers());
    dispatch(getPartnerSuppliers());
    dispatch(getEventsInKyrgyzstan());
    dispatch(getEventsInAzerbaijan());

    params.id && dispatch(getTenderDetails(Number(params.id)));
    params.id && dispatch(getNewsDetails(Number(params.id)));
    params.id && dispatch(getCompletedProjectDetails(Number(params.id)));
    params.id && dispatch(getApprovedProjectDetails(Number(params.id)));
    params.id && dispatch(getEventDetails(Number(params.id)));
  };

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const redirectToPage = (page) => {
    if (page === "about") {
      navigate("/about");
    }
    if (page === "team") {
      navigate("/team");
    }
    if (page === "reports") {
      navigate("/reports");
    }
    if (page === "companies") {
      navigate("/companies");
    }
    if (page === "consultants") {
      navigate("/consultants");
    }
    if (page === "vacancy") {
      navigate("/vacancies");
    }
    if (page === "tenders") {
      navigate("/tenders");
    }
  };

  const options1 = (
    <Menu>
      <Menu.Item key="1" onClick={(e) => redirectToPage("about")}>
        <HomeOutlined className={"icon"} />
        {t("briefInformation")}
      </Menu.Item>
      <Menu.Item key="2" onClick={(e) => redirectToPage("team")}>
        <UserOutlined className={"icon"} />
        {t("executiveBoardandManagement")}
      </Menu.Item>
      <Menu.Item key="3" onClick={(e) => redirectToPage("reports")}>
        <FileProtectOutlined className={"icon"} />
        {t("policies")}
      </Menu.Item>
      <Menu.Item key="4" onClick={(e) => redirectToPage("tenders")}>
        <UserAddOutlined className={"icon"} />
        {t("tenders")}
      </Menu.Item>
      <Menu.Item key="5" onClick={(e) => redirectToPage("vacancy")}>
        <UserAddOutlined className={"icon"} />
        {t("vacancies")}
      </Menu.Item>
      <Link to="/partnersPage">
        <Menu.Item key="9">
          <UserAddOutlined className={"icon"} />
          {t("partners")}
        </Menu.Item>
      </Link>
    </Menu>
  );

  const options2 = (
    <Menu>
      <Menu.Item key="1">
        <Link to="/apprisers">
          <IdcardOutlined className={"icon"} />
          {t("accreditedAppraisers")}
        </Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="/consultants">
          <ContactsOutlined className={"icon"} /> {t("accreditedConsultants")}
        </Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link to="/insuranceCompanies">
          <ContactsOutlined className={"icon"} />{" "}
          {t("accreditedInsuranceCompanies")}
        </Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link to="/partnersPage">
          <TeamOutlined className={"icon"} />
          {t("partners")}
        </Link>
      </Menu.Item>
    </Menu>
  );

  const options6 = (
    <Menu>
      <Menu.Item key="1">
        <div
          onClick={() => {
            showDrawer(true);
          }}
        >
          <FileSyncOutlined className={"icon"} /> {t("application")}
        </div>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to="/requirements">
          <FilePdfOutlined className={"icon"} /> {t("ListofRequiredDocuments")}
        </Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link to="/investmentStrategy">
          <IdcardOutlined className={"icon"} />
          {t("InvestmentStrategy")}
        </Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link to="/investmentPolicy">
          <ContactsOutlined className={"icon"} /> {t("InvestmentPolicy")}
        </Link>
      </Menu.Item>
      <Menu.Item key="5">
        <Link to="/productPassport">
          <ContactsOutlined className={"icon"} />{" "}
          {t("InvestmentFinancingProductPassport")}
        </Link>
      </Menu.Item>
      <SubMenu
        key="sub1"
        icon={<UserAddOutlined className={"icon"} />}
        title={t("Accreditation")}
      >
        <Menu.Item key="6">
          <Link to="/apprisers">
            <IdcardOutlined className={"icon"} />
            {t("accreditedAppraisers")}
          </Link>
        </Menu.Item>
        <Menu.Item key="7">
          <Link to="/consultants">
            <ContactsOutlined className={"icon"} /> {t("accreditedConsultants")}
          </Link>
        </Menu.Item>
        <Menu.Item key="8">
          <Link to="/insuranceCompanies">
            <ContactsOutlined className={"icon"} />{" "}
            {t("accreditedInsuranceCompanies")}
          </Link>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );

  const options4 = (
    <Menu>
      <Menu.Item key="1">
        <div
          onClick={() => {
            dispatch(setLang("ru"));
            changeLang("ru");
          }}
          className="lang_wrapper"
        >
          <img src="/russia.png" className={"flag"} /> RU
        </div>
      </Menu.Item>
      <Menu.Item key="2">
        <div
          onClick={() => {
            dispatch(setLang("en"));
            changeLang("en");
          }}
          className="lang_wrapper"
        >
          <img src="/english.png" className={"en_flag"} /> EN
        </div>
      </Menu.Item>
      <Menu.Item key="3">
        <div
          onClick={() => {
            dispatch(setLang("ky"));
            changeLang("ky");
          }}
          className="lang_wrapper"
        >
          <img src="/kyrgyzstan.png" className={"en_flag"} /> KY
        </div>
      </Menu.Item>
    </Menu>
  );

  const options5 = (
    <Menu>
      {localStorage.getItem("access_token") && (
        <Menu.Item key="2">
          <div
            onClick={() =>
              user?.email
                ? navigate(user.is_admin ? "/adminAccount" : "/myAccount")
                : navigate("/login")
            }
          >
            <UserOutlined className={"icon"} />
            {t("personalAccount")}
          </div>
        </Menu.Item>
      )}
      {localStorage.getItem("access_token") ? (
        <Menu.Item key="3">
          <div
            onClick={() => {
              dispatch(logout());
              navigate("/");
            }}
          >
            <LogoutOutlined className={"icon"} />
            {t("logout")}
          </div>
        </Menu.Item>
      ) : (
        <Menu.Item key="1">
          <Link to="/login">
            <UserOutlined className={"icon"} />
            {t("personalAccount")}
          </Link>
        </Menu.Item>
      )}
    </Menu>
  );

  const options3 = (
    <Menu>
      <Menu.Item key="3">
        <Link
          to="/approvedProjects"
          onClick={() => dispatch(getApprovedProjects())}
        >
          <AuditOutlined className={"icon"} />
          {t("approvedProjects")}
        </Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link
          to="/completedProjects"
          onClick={() => dispatch(getCompletedProjects())}
        >
          <FileDoneOutlined className={"icon"} />
          {t("completedProjects")}
        </Link>
      </Menu.Item>
    </Menu>
  );

  const options7 = (
    <Menu>
      <Menu.Item key="10">
        <Link
          to="/partner-supplier"
          onClick={() => dispatch(getPartnerSuppliers())}
        >
          <IdcardOutlined className={"icon"} />
          {t("Партнеры-поставщики")}
        </Link>
      </Menu.Item>
      <Menu.Item key="11">
        <Link to="/partner-buyer" onClick={() => dispatch(getPartnerBuyers())}>
          <IdcardOutlined className={"icon"} />
          {t("Партнеры-покупатели")}
        </Link>
      </Menu.Item>
      <Menu.Item key="12">
        <Link
          to="/events-in-azerbaijan"
          onClick={() => dispatch(getEventsInAzerbaijan())}
        >
          <IdcardOutlined className={"icon"} />
          {t("Мероприятия в Азербайджане")}
        </Link>
      </Menu.Item>
      <Menu.Item key="13">
        <Link
          to="/events-in-kyrgyzstan"
          onClick={() => dispatch(getEventsInKyrgyzstan())}
        >
          <IdcardOutlined className={"icon"} />
          {t("Мероприятия в Кыргызстане")}
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="header">
      <div className="logo">
        <Link to="/" className="logo_link">
          <img
            src={
              lang === "ru" || lang === "ky"
                ? "/dark_logo.png"
                : "/akdf_logo(eng).png"
            }
            className="header_logo"
          />
        </Link>
      </div>
      <div className={"menu_wrapper"}>
        <ul className={"menu"}>
          <Dropdown overlay={options1}>
            <ol className={location.pathname === "/about" ? "active" : ""}>
              {t("aboutUs")}
            </ol>
          </Dropdown>
          <Dropdown overlay={options6}>
            <ol className={location.pathname === "/about" ? "active" : ""}>
              {t("ForInvestors")}
            </ol>
          </Dropdown>
          <Dropdown overlay={options3}>
            <ol className={location.pathname === "/projects" ? "active" : ""}>
              {t("projects")}
            </ol>
          </Dropdown>
          <Dropdown overlay={options7}>
            <ol className={location.pathname === "/projects" ? "active" : ""}>
              {t("B2B HUB")}
            </ol>
          </Dropdown>
          <ol className={location.pathname === "/news" ? "active" : ""}>
            <Link to="/news" onClick={() => dispatch(getNews())}>
              {t("news")}
            </Link>
          </ol>
          <div style={{ marginLeft: "50px" }}>
            <Dropdown overlay={options4}>
              <ol className={location.pathname === "/news" ? "active" : ""}>
                <div>
                  <GlobalOutlined />
                  &nbsp;{lang === "en" ? "EN" : lang === "ru" ? "RU" : "KY"}
                </div>
              </ol>
            </Dropdown>
          </div>

          <Dropdown overlay={options5}>
            <ol>
              {user?.email ? (
                <div className={"img_wrapper"}>
                  <img src="/assets/noImage.png" className={"img"} />{" "}
                  <CaretDownFilled />
                </div>
              ) : (
                t("personalAccount")
              )}
            </ol>
          </Dropdown>
        </ul>
      </div>
      <ApplicationDrawer open={open} onClose={onClose} />
    </div>
  );
};

export default Header;
